export enum OrganizationEnum {
    SEFIN = 1,
    SEAD = 2,
    SEMURB = 3,
    PGM = 4,
    SESA = 5,
    SAS = 6,
    SDAR = 7,
}